// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { ConfigClient } from 'src/app/clients/config-client';
import { MemberClient } from 'src/app/clients/member-client';
import { MenuClient } from 'src/app/clients/menu-client';
import { OrderClient } from 'src/app/clients/order-client';
import { RewardClient } from 'src/app/clients/reward-client';
import { StoreClient } from 'src/app/clients/store-client';
import { Category } from 'src/app/models/domain/category';
import { Environment } from 'src/app/models/environment';

export const environment: Environment = {
  production: false,
  variables: {
    brandTradeName: 'BurgerFuel Limited',
    brandPath: 'burgerfuel',
    comoLocationId: '9247',
    appInsightsInstrumentationKey: '2ebb6f8d-23bf-4aea-9e8a-8046764c3554',
    pageTitle: '[UAT] BurgerFuel | Order Online',
    favicon: 'assets/burgerfuel/favicon.png',
    baseApiUrl: 'https://api-uat.burgerfuel.com',
    // baseApiUrl: 'https://localhost:5001',
    paymentUrl: 'https://localhost:44396/',
    futureOrderDays: 7,
    defaultMenu: 1,
    logoLocation: 'assets/burgerfuel/logo.svg',
    categoryPLUs: {
      Sauces: 2025,
      'Small Burgers': 2004,
      Minis: 2004,
      'Plant Powered': 2004,
      'Special Desserts': 2058,
      Desserts: 2026,
      'Special Shakes': 2056,
      Shakes: 2034,
      'Special Sides': 2055,
      'Special Burgers': 2054,
      'Kids Meals': 2055,
      Drinks: 2035,
      Sides: 2038,
      'NZ Beef': 2004,
      'Free Range Chicken': 2004,
      Specials: 2054,
    },
    displayCombosSeparately: false,
    comboDisplayName: 'Feed',
    disableTimers: false,
    gtmCode: 'GTM-T66M27Z',
    fbPixelCode: '707631829329831',
    googleMapsApiKey: 'AIzaSyDswZxEyq-zzljdJkr-mwkcDkIxBdqNjVw',
    facebookLink: 'https://www.facebook.com/burgerfuel/',
    instagramLink: 'https://www.instagram.com/burgerfuel/',
    tiktokLink: 'https://www.tiktok.com/@burgerfuel/',
    youtubeLink: 'https://www.youtube.com/user/burgerfuel/',
    privacyLink: 'https://www.burgerfuel.com/nz/privacy-policy',
    termsLink: 'https://www.burgerfuel.com/nz/terms-and-conditions',
    categories: [
      new Category({
        Name: 'Specials',
        DisplayName: 'Specials',
        DisplayOrder: 1,
      }),
      new Category({
        Name: 'NZ Beef',
        DisplayName: 'Beef',
        DisplayOrder: 2,
      }),
      new Category({
        Name: 'Free Range Chicken',
        DisplayName: 'Free Range Chicken',
        DisplayOrder: 3,
      }),
      new Category({
        Name: 'Plant Powered',
        DisplayName: 'Plant-Powered',
        DisplayOrder: 4,
      }),
      new Category({
        Name: 'Minis',
        DisplayName: 'Lightweights',
        DisplayOrder: 5,
      }),
      new Category({
        Name: 'Sides',
        DisplayName: 'Sides',
        DisplayOrder: 6,
      }),
      new Category({
        Name: 'Drinks',
        DisplayName: 'Thickshakes & Drinks',
        DisplayOrder: 7,
      }),
      new Category({
        Name: 'Kids Meals',
        DisplayName: 'Kids Ink. Meals',
        DisplayOrder: 8,
      }),
      new Category({
        Name: 'Sauces',
        DisplayName: 'Sauces',
        DisplayOrder: 9,
      }),
      new Category({
        Name: 'Other',
        DisplayName: 'Other',
        DisplayOrder: 10,
      }),
    ],
    currencyFormat: '1.2-2',
    cateringConfig: {
      cateringEnabled: false,
    },
    loyaltyConfig: {
      pointRatio: 1,
      pointDecimals: 2,
      loyaltyEnabled: true,
      loyaltyLabel: 'BurgerFuel VIB Club',
      loyaltyLink: 'https://www.burgerfuel.com/nz/terms-and-conditions',
      rewardsModalTitle: 'MY CLUB GOODS',
      rewardShopSubtitle: 'BUCKS BANK',
      earnVerb: 'clock',
      pointsName: 'mpb',
      rewardsName: 'Club Good',
      purchaseRewardsEnabled: false,
      loyaltyToggleLabel: 'Opt in to our loyalty programme',
      loyaltyToggleLabelDescription:
        'Get access to exclusive VIB Club offers, promos, prizes & more',
      emailToggleLabel: 'Opt in to receive email notifications',
      emailToggleLabelDescription:
        'Get notified of new offers in your account & get the latest BurgerFuel news',
      usedRewardLockTime: '5 minutes',
      loyaltyLogo: 'assets/burgerfuel/LoyaltyLogo.png',
      loyaltyReferredSignUpText:
        'Sign up to our loyalty programme,</br> BurgerFuel VIB Club! </br></br>' +
        'Get mpb (miles per burger) with every dollar spent to earn Burger Bucks, plus get hooked up with Club Goods along the ride.',
    },
    gstPercentage: 0.15,
    sliderSpeed: 8000,
    mapConfig: {
      features: [
        {
          featureType: 'all',
          stylers: { hue: '#c1b8cd', saturation: -60 },
        },
        {
          featureType: 'road.highway',
          stylers: { hue: '#9c7dc3' },
        },
      ],
      mapMarkers: {
        labelColour: 'hsl(264, 100%, 38%)',
        iconWidth: 55,
        iconHeight: 30,
      },
    },
    notificationsConfig: {
      notificationsEnabled: true,
      showLoyaltySection: true,
    },
  },
  storeClient: StoreClient,
  menuClient: MenuClient,
  orderClient: OrderClient,
  memberClient: MemberClient,
  rewardClient: RewardClient,
  configClient: ConfigClient,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
